import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

// Add-to-home-screen prompt. Uses beforeinstallprompt on Android/Chrome;
// shows a manual hint on iOS Safari (which has no install event).
export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("tp_install_dismissed")) return;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;

    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);

    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(window.navigator.userAgent);
    if (isIos && isSafari) { setIosHint(true); setShow(true); }

    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { setShow(false); localStorage.setItem("tp_install_dismissed", "1"); };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null); dismiss();
  };

  if (!show) return null;

  return (
    <div data-testid="install-prompt" className="no-print fixed inset-x-3 bottom-24 z-40 mx-auto max-w-md rounded-2xl border border-border bg-white/95 p-4 shadow-xl backdrop-blur sm:left-5 sm:right-auto">
      <button onClick={dismiss} data-testid="install-dismiss" className="absolute right-3 top-3 text-muted-foreground hover:text-[#2C363F]"><X className="h-4 w-4" /></button>
      <div className="flex items-start gap-3 pr-5">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#4A7c59] text-white"><Download strokeWidth={1.8} className="h-5 w-5" /></div>
        <div>
          <p className="font-head font-semibold text-[#2C363F]">Add TaperPath to your home screen</p>
          {iosHint ? (
            <p className="mt-1 flex items-center gap-1 text-sm text-muted-foreground">Tap <Share className="inline h-4 w-4" /> then "Add to Home Screen" — unlocks reminders on iPhone.</p>
          ) : (
            <>
              <p className="mt-1 text-sm text-muted-foreground">Open it like an app and get reminders even when it's closed.</p>
              <button onClick={install} data-testid="install-accept" className="mt-3 rounded-full bg-[#4A7c59] px-4 py-2 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5">Install app</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
